module.exports = __webpack_public_path__ + "img/L_5H.45dc12cc.png";